import { AuthAttribute, pickRoleAttrs, userIdToAuthAttribute } from "@megaron/access-control";

/**
 * Assignee e-mails are compared as exact `keyword` terms once they become auth attributes, so every
 * producer and consumer has to agree on a single casing.
 */
export const normalizeTicketUserEmail = (email: string): string => email.trim().toLowerCase();

/** Roles that may open the "Zgłoszenia" nav link, list tickets and therefore receive ticket signals. */
export const ticketViewerRoleAttributes: AuthAttribute[] = pickRoleAttrs(
  "support.viewer",
  "support.user",
  "support.status-manager",
  "support.admin",
  "crm.user",
  "crm.admin",
);

export const ticketAccessAttributes = (assigneeEmails: readonly string[]): AuthAttribute[] => [
  ...new Set<AuthAttribute>([
    ...ticketViewerRoleAttributes,
    ...assigneeEmails.map((email) => userIdToAuthAttribute(normalizeTicketUserEmail(email))),
  ]),
];
